module.exports = __webpack_public_path__ + "img/amores.0ac87169.png";